import React, { useEffect } from 'react';

export default function SEOHead({ 
  title = "Chaitanya Shooting Academy | Train Like A Champion",
  description = "Elite precision shooting academy in Gurugram. Learn from certified coaches. Olympic-standard facilities. Book your free trial today!",
  canonicalUrl = "https://chaitanyashooting.com",
  ogImage = "https://chaitanyashooting.com/images/academy-bg.jpg",
  keywords = "shooting academy, air rifle training, precision shooting, Gurugram, shooting lessons"
}) {
  
  useEffect(() => {
    // Update Meta Tags
    document.title = title;
    
    const updateMeta = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.name = name;
        document.head.appendChild(element);
      }
      element.content = content;
    };

    const updateProperty = (property, content) => {
      let element = document.querySelector(`meta[property="${property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', property);
        document.head.appendChild(element);
      }
      element.content = content;
    };

    // Update standard meta tags
    updateMeta('description', description);
    updateMeta('keywords', keywords);
    updateMeta('viewport', 'width=device-width, initial-scale=1.0');
    updateMeta('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    updateMeta('author', 'Chaitanya Shooting Academy');
    updateMeta('language', 'English');

    // Update Open Graph tags
    updateProperty('og:title', title);
    updateProperty('og:description', description);
    updateProperty('og:image', ogImage);
    updateProperty('og:url', canonicalUrl);
    updateProperty('og:type', 'website');
    updateProperty('og:site_name', 'Chaitanya Shooting Academy');

    // Update Twitter Card tags
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);
    updateMeta('twitter:image', ogImage);
    updateMeta('twitter:creator', '@chaitanyashooting');

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonicalUrl;

    // Structured Data (Schema.org)
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Chaitanya Shooting Academy",
      "image": ogImage,
      "description": description,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Sector 81, Gurugram",
        "addressLocality": "Gurugram",
        "addressRegion": "Haryana",
        "postalCode": "122050",
        "addressCountry": "IN"
      },
      "telephone": "+91-96535-24055",
      "url": canonicalUrl,
      "sameAs": [
        "https://www.instagram.com/chaitanyashootingacademy/",
        "https://facebook.com/chaitanyashooting"
      ],
      "priceRange": "₹6000-₹18000"
    });
    
    // Remove old schema if exists
    const oldSchema = document.querySelector('script[type="application/ld+json"]');
    if (oldSchema) oldSchema.remove();
    
    document.head.appendChild(schemaScript);

  }, [title, description, canonicalUrl, ogImage, keywords]);

  return null;
}
